module.exports = __webpack_public_path__ + "static/media/homepage2.d25bc1ec.jpg";